// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import jQuery from 'jquery';
import Vue from 'vue'
import vueResource from 'vue-resource';
import App from './App'
import router from './router'
import Es6Promise from 'es6-promise';
import moment from 'moment';
import L from 'leaflet';
import LeafletDraw from 'leaflet-draw';
import LeafletEasybutton from 'leaflet-easybutton';
import LeafletFullscreen from 'leaflet-fullscreen';
import * as proj4x from 'proj4/dist/proj4-src.js';
import 'babel-polyfill';
import 'webrtc-adapter';
import { store } from './store/store'
Es6Promise.polyfill();

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

window.proj4 = proj4x.default;
window.jQuery = jQuery;
window.$ = jQuery;
window['moment'] = moment;
window['L'] = L;
window.MotionUI = require('motion-ui');

// Values 
window['apikey'] = '';
window['user'] = '';
window['url'] = '';
window['version'] = '';
window['selectedDate'] = null;

require('foundation-sites');
require('leaflet/dist/leaflet.css');
require('leaflet-draw/dist/leaflet.draw.css');
require('leaflet-easybutton/src/easy-button.css');
require('proj4leaflet');
var VueCookie = require('vue-cookie');

Vue.use(vueResource);
Vue.use(VueCookie);

Vue.http.interceptors.push((request, next) => {
  request.credentials = true;
  request.headers.set('Authorization', 'Basic ' + btoa('auth:'+ window['apikey']));
  next();
});

Vue.http.options.credentials = true;

Vue.http.options.xhr = {
  withCredentials: true
}
Vue.http.options.emulateJSON = true
Vue.http.options.emulateHTTP = true
Vue.http.options.crossOrigin = true

Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
Vue.http.headers.common['Content-Type'] = 'application/json'
Vue.http.headers.common['Accept'] = 'application/json'
Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

$(document).foundation();

moment.locale('da');


// WEBPACK FOOTER //
// ./src/main.js